import { Trans } from '@lingui/macro';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from '@mui/material';
import { formatNumber } from 'utils/common';

const UsingLimit = () => {
  return (
    <Paper>
      <div className='bg-primary-main text-white rounded-t px-3 py-2'>
        <Typography variant='h4'>
          <Trans>TÌNH HÌNH SỬ DỤNG HẠN MỨC</Trans>
        </Typography>
      </div>
      <div className='p-3'>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableCell>
                <Trans>Company Name</Trans>
              </TableCell>
              <TableCell>
                <Trans>Labour Type</Trans>
              </TableCell>
              <TableCell>
                <Trans>Advance Limit (VND)</Trans>
              </TableCell>
              <TableCell>
                <Trans>Available Limit (VND)</Trans>
              </TableCell>
              <TableCell>
                <Trans>Max Labor of Advance</Trans>
              </TableCell>
              <TableCell>
                <Trans>Request</Trans>
              </TableCell>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className='text-center'>Company A</TableCell>
                <TableCell className='text-center'>Full-time</TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>12</TableCell>
                <TableCell className='text-center'>
                  <Button size='small' color='info'>
                    <Trans>Request</Trans>
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className='text-center'>Company B</TableCell>
                <TableCell className='text-center'>Part-time</TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>13</TableCell>
                <TableCell className='text-center'>
                  <Button size='small' color='info'>
                    <Trans>Request</Trans>
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} className='text-center'>
                  Sum
                </TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>{formatNumber(10000000)}</TableCell>
                <TableCell className='text-center'>14</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
};

export default UsingLimit;
